const { getOffsetTop } = window.BAO.Utils

class FixedNav extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.externalEls?.start?.exists) return

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.safeZone = getOffsetTop(this.externalEls.start.element)
  }

  setupListeners () {
    super.setupListeners()

    if (!this.externalEls?.start?.exists) return

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    this.handleClick = this.handleClick.bind(this)

    this.listeners.add(document, 'click', this.handleClick)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setScrolled()
  }

  setScrolled () {
    this.classList.toggle('prd-Detail_FixedNav-hidden', this.isPassedForm)
  }

  handleClick (event) {
    const clickedTrigger = event.target.closest(this.els.trigger.selector)

    if (!clickedTrigger) return

    const matchElement = document.querySelector(
      `[data-fixed-nav-external-el="${clickedTrigger.dataset.element}"]`,
    )

    if (!matchElement) return

    matchElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  get isPassedForm () {
    return this.lastKnownY <= this.safeZone
  }
}

if (!customElements.get('fixed-nav')) {
  customElements.define('fixed-nav', FixedNav)
}
